module.exports = __webpack_public_path__ + "static/Apercu-Mono-66402a7c202cc508cd52d7a7586938f2.otf";